import React from "react";
import Dashboard from "./dashboard/Dashboard";
import Client from "./client/Client";
import DevelopmentRequest from "./developmentRequest/DevelopmentRequest";
import "../../../css/page/Content.css";

const Content = props => {
    const { page } = props;

    const goContent = () => {
        switch (page) {
            case "dashboard": return <Dashboard />;
            case "client": return <Client />;
            case "developmentRequest": return <DevelopmentRequest />;
            default: return <div />
        }
    }

    return (
        <div id={"content"} className="content">
            { goContent() }
        </div>
    )
}

export default Content;
